import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReadingIntentionsMenuComponent } from './reading-intention/reading-intentions-menu.component';
import { ReadingIntentionsMenuModule } from './reading-intention/reading-intentions-menu.module';
import { StudyNoteComponent, StudyNoteModule } from './study-note';

@NgModule({
  imports: [CommonModule, ReadingIntentionsMenuModule, StudyNoteModule],
  exports: [ReadingIntentionsMenuComponent, StudyNoteComponent],
})
export class AnnotationsModule {}
